import { Phone, CalendarCheck } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons";
import { DOCTOR, whatsappLink } from "@/config/doctorConfig";
import { scrollToSection } from "@/lib/scroll";

export const MobileActionBar = () => (
  <nav
    className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(10,37,64,0.25)]"
    aria-label="Quick actions"
    data-testid="mobile-action-bar"
  >
    <div className="grid grid-cols-3">
      <a
        href={DOCTOR.clinicPhoneHref}
        data-testid="mobile-bar-call-btn"
        className="flex flex-col items-center gap-1 py-3 text-navy-900 active:bg-slate-100"
      >
        <Phone size={19} />
        <span className="text-[11px] font-semibold">Call</span>
      </a>
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bar-whatsapp-btn"
        className="flex flex-col items-center gap-1 py-3 text-[#128C7E] active:bg-slate-100"
      >
        <WhatsAppIcon size={19} />
        <span className="text-[11px] font-semibold">WhatsApp</span>
      </a>
      <button
        onClick={() => scrollToSection("appointment")}
        data-testid="mobile-bar-book-btn"
        className="flex flex-col items-center gap-1 py-3 text-white bg-navy-900"
      >
        <CalendarCheck size={19} />
        <span className="text-[11px] font-semibold">Book Appointment</span>
      </button>
    </div>
  </nav>
);
